// LANGUAGES

export const LANGUAGES = [
  {
    label: 'English',
    key: 'english',
    locale: 'en'
  },
  {
    label: 'Russian',
    key: 'russian',
    locale: 'ru'
  },
  {
    label: 'German',
    key: 'german',
    locale: 'de'
  }
  // {
  //   label: 'Ukrainian',
  //   key: 'ukrainian',
  //   locale: 'ua'
  // }
];

// GANDER

export const GANDER_MALE_VALUE = 1;
export const GANDER_FEMALE_VALUE = 2;

export const GENDERS = [
  {
    value: GANDER_MALE_VALUE,
    label: 'male'
  },
  {
    value: GANDER_FEMALE_VALUE,
    label: 'female'
  }
];

// Accepts both the legacy numeric values (1/2 — GQL and old rows) and the
// v2 REST string values ('male'/'female').
export const GENDERS_VALUES: { [key: number | string]: string } = {
  [GANDER_MALE_VALUE]: 'male',
  [GANDER_FEMALE_VALUE]: 'female',
  male: 'male',
  female: 'female'
};

export type GenderKeyType = keyof typeof GENDERS_VALUES;

// PLANS

export const PLAN_TYPE_VALUES = {
  video_call: 1,
  report: 2
};

// Accepts both the legacy numeric plan types (GQL) and the v2 REST
// text values.
export const PLAN_TYPE_LABELS: { [key: number | string]: string } = {
  1: 'video_call',
  2: 'report',
  video_call: 'video_call',
  report: 'report'
};

export const PLAN_TYPES = [
  {
    value: PLAN_TYPE_VALUES.video_call,
    label: 'video_call'
  },
  {
    value: PLAN_TYPE_VALUES.report,
    label: 'report'
  }
];
